
import { trackEvent, trackRegisterClick } from "../utils/analytics";

export const AnalyticsHandle = () => {
    const logAnalyticsEvent = (eventName, eventParams = {}) => {
        trackEvent(eventName, eventParams);
    };

    return { logAnalyticsEvent, logRegisterClick: trackRegisterClick };
};
